import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from './useQueryParams';
import { GatePath } from '../Pages/SiteLevelGate/SiteSearchGate';
const MY_DOMAINS_EMPTY_STATE_REFERRAL = 'mydomains__emptyState';
const SETTINGS_LOBBY_PAGE_COMPONENT_ID = '29570214-f230-4228-9209-f09efb53f768';
export const useViewTransition = () => {
  const history = useHistory();
  const {
    getQueryParam
  } = useQueryParams();
  const navigateTo = useCallback((path, state, options) => {
    const {
      transition = true
    } = options ?? {};
    if (!transition || !document.startViewTransition) {
      history.push(path, state);
      return;
    }
    document.startViewTransition(() => {
      history.push(path, state);
    });
  }, [history]);
  const navigateBack = useCallback(options => {
    const {
      transition = true
    } = options ?? {};
    const performGoBack = () => goBack(getQueryParam, history);
    if (!transition || !document.startViewTransition) {
      performGoBack();
      return;
    }
    document.startViewTransition(() => {
      performGoBack();
    });
  }, [getQueryParam, history]);
  return {
    navigateTo,
    navigateBack
  };
};
const goBack = (getQueryParam, history) => {
  if (window.self !== window.top && window.BusinessManagerAPI) {
    var _BusinessManagerAPI;
    return (_BusinessManagerAPI = window.BusinessManagerAPI) == null ? void 0 : _BusinessManagerAPI.navigateTo({
      pageComponentId: SETTINGS_LOBBY_PAGE_COMPONENT_ID
    });
  }
  const referralAdditionalInfoParam = getQueryParam('referralAdditionalInfo');
  const referralInfoParam = getQueryParam('referralInfo');
  const referralAdditionalInfo = referralInfoParam ?? referralAdditionalInfoParam;
  const cameFromSettings = !history.location.pathname.includes(GatePath.RESULTS) && referralAdditionalInfo === MY_DOMAINS_EMPTY_STATE_REFERRAL;
  const goBackDepth = cameFromSettings ? -3 : -1;
  return history.go(goBackDepth);
};
//# sourceMappingURL=useViewTransition.js.map